import React, { useCallback } from 'react';
import { gql, useQuery } from '@apollo/client';

import { useUrlParams } from '../../../hooks';
import { DiscoverActions } from '../../../zustand-stores/DiscoverStore';

import classNames from 'classnames/bind';
import styles from '../../../styles/main.module.scss';

const cx = classNames.bind(styles);

const { updateCityFilter } = DiscoverActions;

const ORGANIZATION_LIST_QUERY = gql`
  query organizationList {
    organizationList {
      _id
      name
    }
  }
`;

const SelectACity = () => {
  const { data, loading, error } = useQuery(ORGANIZATION_LIST_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const organizationsList = data?.organizationList || [];

  const { updateUrlParams } = useUrlParams();

  const onCityClick = useCallback(
    cityName => {
      updateUrlParams({ cityName });
      updateCityFilter(cityName);
    },
    [updateUrlParams]
  );

  return (
    <div className={cx('select-a-city')}>
      {loading ? null : (
        <>
          <h2>Select Location</h2>
          <div className={cx('content')}>
            {error ? <div>{JSON.stringify(error)}</div> : null}
            {organizationsList.map(({ name, _id }, i) => {
              const key = `city-${i}-${_id}`;
              return (
                <button
                  type="button"
                  tabIndex={0}
                  key={key}
                  className={cx('card')}
                  onClick={() => onCityClick(name)}
                >
                  <h2 className={cx('cityName')}>{name}</h2>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default SelectACity;
